import { FBPageTableContainer } from 'components/FbUI/Page/styles'
import { AutomationsTable } from 'features/settings/components/AutomationsTable'

export function AutomationsSettingsPage() {
  return (
    <div className="w-full h-full flex flex-col flex-1 min-h-0">
      <FBPageTableContainer>
        <AutomationsTable />
      </FBPageTableContainer>
    </div>
  )
}
